<div class="row">
  <div class="col">
    Business Type: {{data['business_name']}}
  </div>

  <div class="col">
    Product: {{data['product_name']}}
  </div>
  <div class="col">
    <button mat-raised-button (click)="removeCalled()" style="background: red; color: white;">Remove Product</button>
  </div>
</div>
<div class="form-group">
  <label>Discount Price</label>
  <input type="number" class="form-control" #new_discount_price [(ngModel)]="discount_price">
</div>
<div class="row">
  <div class="col">
    <button style="margin-left: 40%;" mat-raised-button color="primary"
      (click)="updateDiscountPrice(new_discount_price.value)" [disabled]="discount_price <= 0">Update</button>
  </div>
  <div class="col">
    <button style="margin-left: 40%;" mat-raised-button color="primary" (click)="closeComponent(null)">Close</button>
  </div>
</div>

